export default __webpack_public_path__ + "static/media/1.229d9f2d.png";